import withProgress from './withProgress';

export default withProgress;
